import React from 'react';
  
const Contact = () => {
  return (
    <div>
      <p>Mail us on 123@gmail.com
      We’ll use your personal information only to communicate and handle your inquiry.

From time to time, we would like to contact you about our products and services and other content that may interest you. If you consent to contact for this purpose, please tick below:


I agree to receive other marketing communications from Survicate.
You can unsubscribe at any time by responding to any of our communication or by sending a request to gdpr@survicate.com. We will store and process your personal data on terms defined here.</p>
    </div>
  );
};
  
export default Contact;